import React from 'react';
import { InstagramIcon, FacebookIcon, LinkedinIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { openCalendlyPopup } from '../utils/calendly';
export function Footer() {
  const {
    t,
    language
  } = useLanguage();
  const isEnglish = language === 'en';
  const footerLinks = {
    company: [{
      label: t('footer.contact'),
      href: '#',
      isCalendly: true
    }],
    legal: [{
      label: t('footer.privacy'),
      href: '/datenschutz'
    }, {
      label: t('footer.imprint'),
      href: '/impressum'
    }]
  };
  const handleCalendlyClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    openCalendlyPopup();
  };
  return <footer className="bg-[#0a0e1a] border-t border-white/5" data-id="element-104">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-16" data-id="element-105">
        <div className="grid grid-cols-2 md:grid-cols-3 gap-8 lg:gap-12" data-id="element-106">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1" data-id="element-107">
            <Link to="/" className="flex items-center gap-2 mb-4" data-id="element-108">
              <span className="text-xl font-bold text-white" data-id="element-109">CRM</span>
              <span className="text-xl font-bold text-[#ff6b35]" data-id="element-110">Kraft</span>
            </Link>
            <p className="text-gray-400 text-sm mb-4" data-id="element-111">{t('footer.tagline')}</p>
            <address className="not-italic text-sm text-gray-400 space-y-1 mb-6" data-id="element-112">
              <p data-id="element-113">CRM Kraft LLC</p>
              <a href="mailto:justus@crm-kraft.de" className="block hover:text-white transition-colors" data-id="element-114">
                {isEnglish ? 'Email: justus@crm-kraft.de' : 'E-Mail: justus@crm-kraft.de'}
              </a>
              <a href="tel:+4915735999071" className="block hover:text-white transition-colors" data-id="element-115">
                {isEnglish ? 'Phone: +49 157 35999071' : 'Telefon: +49 157 35999071'}
              </a>
            </address>
            <div className="flex gap-4" data-id="element-116">
              <a href="https://www.instagram.com/kraftjustus/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-[#ff6b35] transition-colors" aria-label="Instagram" data-id="element-117">
                <InstagramIcon className="w-5 h-5" data-id="element-118" />
              </a>
              <a href="https://www.facebook.com/kraftjustus" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-[#ff6b35] transition-colors" aria-label="Facebook" data-id="element-119">
                <FacebookIcon className="w-5 h-5" data-id="element-120" />
              </a>
              <a href="https://www.linkedin.com/in/justus-kraft/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-[#ff6b35] transition-colors" aria-label="LinkedIn" data-id="element-121">
                <LinkedinIcon className="w-5 h-5" data-id="element-122" />
              </a>
            </div>
          </div>

          {/* Company Links */}
          <div data-id="element-123">
            <h4 className="text-white font-semibold mb-4" data-id="element-124">
              {t('footer.company')}
            </h4>
            <ul className="space-y-3" data-id="element-125">
              {footerLinks.company.map(link => <li key={link.label} data-id="element-126">
                  <a href={link.href} onClick={handleCalendlyClick} className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer" data-id="element-127">
                    {link.label}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Legal Links */}
          <div data-id="element-128">
            <h4 className="text-white font-semibold mb-4" data-id="element-129">
              {t('footer.legal')}
            </h4>
            <ul className="space-y-3" data-id="element-130">
              {footerLinks.legal.map(link => <li key={link.label} data-id="element-131">
                  <Link to={link.href} className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-132">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-white/5 text-center" data-id="element-133">
          <p className="text-gray-500 text-sm" data-id="element-134">{t('footer.copyright')}</p>
        </div>
      </div>
    </footer>;
}